import { VideoCameraOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { UserInfoContext } from "Context/CommonContext";
import useResponsive from "Context/useResponsive";
import React, { useContext } from "react";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { CLASS_URL_ENCODE_STRING } from "utilFunctions/Constants/Constants";
import { Buffer } from "buffer";
interface JoinLectureProps {
  eventLink: string;
  message?: string;
}
function processEventLink(
  input: string | null,
  substring: string,
  userInfo: any
): any {
  if (!input || input.trim() === "" || !input.includes(substring)) {
    return input;
  }

  const splitOnQuestionMark = input.split("?");
  if (splitOnQuestionMark.length !== 2) {
    return null;
  }

  const roomId = splitOnQuestionMark[1].split("=");
  if (roomId.length !== 2) {
    return null;
  }

  const isPresenter = "1";
  const encId = mnEncodeBase64(
    roomId[1] + "_" + userInfo.employeeId + "_" + `${isPresenter}` + "_1"
  );

  return splitOnQuestionMark[0] + `/${encId}`;
}
const mnEncodeBase64 = (data: any) => {
  const key = CLASS_URL_ENCODE_STRING;
  let temp: any = Buffer.from(data).toString("base64");
  const mapObj: { [key: string]: string } = {
    "+": "@",
    "/": "$",
    "=": "!",
    "&": "^",
    "?": "#",
  };

  for (const key in mapObj) {
    if (Object.prototype.hasOwnProperty.call(mapObj, key)) {
      while (temp.indexOf(key) !== -1) {
        temp = temp.replace(key, mapObj[key]);
      }
    }
  }
  return key + temp;
};
const JoinLecture = ({ eventLink, message }: JoinLectureProps) => {
  const { isMobile } = useResponsive();
  const userInfo = useContext<IUserInfo>(UserInfoContext);

  return (
    <Button
      onClick={() =>
        eventLink &&
        window.open(processEventLink(eventLink, "crystal", userInfo), "_blank")
      }
      style={{
        backgroundColor: "var(--primary-text)",
        color: "#ffffff",
        border: "none",
        borderRadius: "10px",
        padding: "10px 20px",
        fontWeight: 600,
        fontSize: "14px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "8px",
      }}
      icon={<VideoCameraOutlined style={{ fontSize: "16px" }} />}
      size={isMobile ? "small" : "large"}
    >
      {message || "Join Lecture"}
    </Button>
  );
};

export default JoinLecture;
